export default {
  pqmRow1: 'Quality Cloud消除了PCBA，注塑成型和钣金制造商当前依赖的质量管理流程中固有的不一致和复杂性，使他们能够提供高质量的产品，同时平衡时间和成本要求，以实现最佳的客户满意度。',
  pqmRow2: '实时监控制造过程，以快速识别和响应质量事件并确定质量问题的根本原因，以实现闭环问题解决。',
  pqmRow3: '利用JWI的数字链将反馈回路扩展到供应链中。',
  pqmRow4: '内置的机器学习和数据分析功能可通过新的见解持续、智能地优化质量过程，从而不断改进并显着减少缺陷，报废和返工。'
}
